import { Accordion, AccordionTab } from 'primereact/accordion';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Menu } from 'primereact/menu';
import { TabPanel, TabView } from 'primereact/tabview';
import { useRef, useState } from 'react';

export const NavigationSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const menuRef = useRef<Menu>(null);

  const breadcrumbHome = { icon: 'pi pi-home', url: '#' };
  const breadcrumbItems = [
    { label: 'Projects' },
    { label: 'My Project' },
    { label: 'Settings' },
  ];

  const menuItems = [
    {
      label: 'File',
      items: [
        {
          label: 'New',
          icon: 'pi pi-plus',
        },
        {
          label: 'Open',
          icon: 'pi pi-folder-open',
        },
        {
          label: 'Save',
          icon: 'pi pi-save',
        },
      ],
    },
    {
      label: 'Edit',
      items: [
        {
          label: 'Cut',
          icon: 'pi pi-times',
        },
        {
          label: 'Copy',
          icon: 'pi pi-copy',
        },
        {
          label: 'Paste',
          icon: 'pi pi-file',
        },
      ],
    },
  ];

  return (
    <div id='navigation' className='space-y-6'>
      <div>
        <h2 className='text-2xl font-bold mb-2'>Navigation</h2>
        <p className='text-gray-600 mb-4'>
          Navigation components for moving through the application.
        </p>
      </div>

      {/* Breadcrumb */}
      <Card title='Breadcrumb' className='mb-4'>
        <BreadCrumb model={breadcrumbItems} home={breadcrumbHome} />
      </Card>

      {/* TabView */}
      <Card title='TabView' className='mb-4'>
        <TabView
          activeIndex={activeIndex}
          onTabChange={e => setActiveIndex(e.index)}
        >
          <TabPanel header='Summary'>
            <p className='text-gray-600 py-4'>
              Summary tab content goes here. This is the first tab with general
              information.
            </p>
          </TabPanel>
          <TabPanel header='Details'>
            <p className='text-gray-600 py-4'>
              Details tab content. This tab contains more specific information
              about the item.
            </p>
          </TabPanel>
          <TabPanel header='Settings'>
            <p className='text-gray-600 py-4'>
              Settings tab content. Configure options and preferences here.
            </p>
          </TabPanel>
          <TabPanel header='History'>
            <p className='text-gray-600 py-4'>
              History tab content. View past activities and changes.
            </p>
          </TabPanel>
        </TabView>
      </Card>

      {/* Menu */}
      <Card title='Menu' className='mb-4'>
        <div className='flex gap-4'>
          <div>
            <Button
              label='Show Menu'
              icon='pi pi-bars'
              onClick={e => menuRef.current?.toggle(e)}
            />
            <Menu model={menuItems} popup ref={menuRef} />
          </div>
          <div className='border rounded-lg p-4 flex-1'>
            <p className='text-sm text-gray-600 mb-2'>Static Menu Example:</p>
            <Menu model={menuItems} className='w-full border-0' />
          </div>
        </div>
      </Card>

      {/* Accordion */}
      <Card title='Accordion' className='mb-4'>
        <Accordion>
          <AccordionTab header='Section 1'>
            <p className='text-gray-600'>
              Content for the first accordion section. Accordions are great for
              organizing related content in a collapsible format.
            </p>
          </AccordionTab>
          <AccordionTab header='Section 2'>
            <p className='text-gray-600'>
              Content for the second section. Users can expand multiple sections
              at once or configure for single expansion.
            </p>
          </AccordionTab>
          <AccordionTab header='Section 3'>
            <p className='text-gray-600'>
              Third section content. Each section can contain any type of
              content including forms, tables, or other components.
            </p>
          </AccordionTab>
        </Accordion>
      </Card>

      {/* Sidebar Navigation Example */}
      <Card title='Sidebar Navigation Pattern' className='mb-4'>
        <div className='bg-stone-800 text-white rounded-lg p-4 w-64'>
          <div className='space-y-2'>
            <div className='flex items-center gap-3 px-3 py-2 rounded bg-stone-700 cursor-pointer'>
              <i className='pi pi-folder'></i>
              <span>Projects</span>
            </div>
            <div className='flex items-center gap-3 px-3 py-2 rounded hover:bg-stone-700 cursor-pointer'>
              <i className='pi pi-list'></i>
              <span>Surveys</span>
            </div>
            <div className='flex items-center gap-3 px-3 py-2 rounded hover:bg-stone-700 cursor-pointer'>
              <i className='pi pi-file-edit'></i>
              <span>Prompts</span>
            </div>
            <div className='flex items-center gap-3 px-3 py-2 rounded hover:bg-stone-700 cursor-pointer'>
              <i className='pi pi-book'></i>
              <span>Style Guide</span>
            </div>
          </div>
        </div>
        <p className='text-sm text-gray-500 mt-3'>
          This is the sidebar navigation pattern used in the main application
          layout.
        </p>
      </Card>
    </div>
  );
};
